import { ManagerService } from '@Services/managers/managers.service';
import { ToolsService } from '@Services/tools/tools.service';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-manager-profile-block-modal',
  templateUrl: './manager-profile-block-modal.component.html',
  styleUrls: ['./manager-profile-block-modal.component.scss'],
})
export class ManagerProfileBlockModalComponent implements OnInit {
  selectionList: any;
  managerClinicalPreferences: any;

  constructor(private toolsService: ToolsService, private managerService: ManagerService, private modalCtrl: ModalController) {}

  ngOnInit() {
    this.selectionList = {
      neededspecialties: {},
      interestedstates: {},
      prohibitedstates: {},
      studenttype: {},
      requiredinpatientspecialties: {},
    };

    this.toolsService.content.subscribe((data: any) => {
      const updatedStudentTypeList = [...data.management.page.provisional.list.studenttypes];
      // remove "Other" from the list
      const index = updatedStudentTypeList.indexOf('Other');
      if (index > -1) {
        updatedStudentTypeList.splice(index, 1);
      }
      this.selectionList.studenttype.startOptions = [...updatedStudentTypeList]?.map(type => {
        return { optionText: type, optionValue: type };
      });
    });

    this.selectionList.studenttype.startOptions.unshift({ optionText: 'All', optionValue: 'All' });

    // populate the utilized list
    for (const key in this.selectionList) {
      this.selectionList[key].list = JSON.stringify({
        id: key,
        optionItems: this.selectionList[key].startOptions,
      });
    }
  }

  // fnc controlling all multiselects
  selection(ev: CustomEvent) {
    const id = (ev.target as HTMLInputElement).id;
    if (ev.detail.actionType === 'selection') {
      // check for all selection and add all options
      if (ev.detail.value.includes('All')) {
        this.selectionList[id].selection = 'All';
        this.selectionList[id].startOptions.forEach(option => {
          if (option.optionValue !== 'All') {
            ev.detail.value.push(option.optionValue);
          }
        });
        // remove all from the selection
        const index = ev.detail.value.indexOf('All');
        if (index > -1) {
          ev.detail.value.splice(index, 1);
        }
      }
      this.selectionList[id].selection = ev.detail.value.join(',');
    } else if (ev.detail.actionType === 'search') {
      const filterKey = ev.detail.value.toLowerCase();
      if (filterKey !== null && filterKey.length > 0) {
        const filteredList = [...this.selectionList[id].startOptions]
          .filter(items => {
            if (items.optionValue.toLowerCase().indexOf(filterKey) > -1) {
              return items;
            }
          })
          .sort((a, b) => a.optionText.localeCompare(b.optionText));

        this.selectionList[id].list = JSON.stringify({
          id,
          optionItems: filteredList,
        });
      }
    } else if (ev.detail.actionType === 'reset') {
      this.selectionList[id].list = JSON.stringify({
        id,
        optionItems: this.selectionList[id].startOptions,
      });
    }
  }

  save() {
    const selection = this.selectionList?.studenttype.selection;
    // save the selection
    this.managerService.saveManagerClinicalPreferences({ ManagerClinicalPreference: { studenttype: selection } }).subscribe((response: any) => {
      if (response.success) {
        this.modalCtrl.dismiss(true);
      } else {
        // show error
        alert('Error saving the selection');
      }
    });
  }

  dismiss(action: boolean) {
    try {
      this.modalCtrl.dismiss(action);
    } catch (error) {
      console.log('error', error);
    }
  }
}
